import * as Sentry from '@sentry/browser';

// TYPES
import { ERROR_FEEDBACK } from '../../types';

// UTILITIES
import findErrorUTL from '../../../utils/findErrorUTL';
import loggerUTL from '../../../utils/loggerUTL';

const feedbackCZ = (errors, dispatch) => {
  loggerUTL('ERRORS...', errors);
  const inputError = {
    personalInformation: {},
    currentResidentialAddress: {},
    taxIDNo: {}
  };

  try {
    if(findErrorUTL(errors, 'firstName')) {
      inputError.personalInformation.firstName = `First name is ${
        errors.find((item) => item.includes('firstName')).split(':')[1]
      }`;
    }
    if(findErrorUTL(errors, 'lastName')) {
      inputError.personalInformation.lastName = `Last name is ${
        errors.find((item) => item.includes('lastName')).split(':')[1]
      }`;
    }
    if(findErrorUTL(errors, 'gender')) {
      inputError.personalInformation.gender = `${
        errors.find((item) => item.includes('gender'))
      }`;
    }
    if(findErrorUTL(errors, 'dateOfBirth')) {
      inputError.personalInformation.dateOfBirth = `${
        errors.find((item) => item.includes('dateOfBirth'))
      }`;
    }
    if(findErrorUTL(errors, 'addressElement5')) {
      inputError.currentResidentialAddress.postCode = `Post Code is ${
        errors.find((item) => item.includes('addressElement5')).split(':')[1]
      }`;
    }
    if(findErrorUTL(errors, 'taxIDNo')) {
      inputError.taxIDNo.taxIDNo = `Tax ID number is ${
        errors.find((item) => item.includes('taxIDNo')).split(':')[1]
      }`;
    }
  } catch (err) {
    Sentry.captureException(
      'FAILED TO PARSE CZECH REPUBLIC VALIDATION ERRORS...',
      JSON.stringify
    )(errors);
  }

  dispatch({
    type: ERROR_FEEDBACK,
    payload: inputError,
  });
};

export default feedbackCZ;